module.exports = __webpack_public_path__ + "img/ocue-about-3.5ce1a137.jpg";